module.exports = __webpack_public_path__ + "static/media/IMG_0753.738d7407.jpg";